import eventBus from '@sd-utility/eventbus';
import { Tracking } from '../types/search-response';

export const publishAnalyticEvent = (data: Tracking | null) => {
  if (typeof window === 'undefined' || data === null) return;
  eventBus.publish('listing/update', { ...data });
};
